import "./jquery-cookie";
import "./cookie";
import gsapAnim from "./gsap";
// import './modal' // Animsition(); ← 単独でfunctions.phpから読み込むことにした

window.onload = function () {
  gsapAnim();

  /**
   * セミナーのテーマエアの高さ設定
   */
  // const setThemeAreaHeight = () => {
  //   const themeAreaHeight = document.getElementById("theme").clientHeight;

  //   if (themeAreaHeight) {
  //     document.querySelector(".bg-for-about").style.height = `${themeAreaHeight}px`;
  //   }
  // };
  // setThemeAreaHeight();

  // window.addEventListener("resize", function () {
  //   setThemeAreaHeight();
  // });
};
